import { memo } from 'react';

import { type Tag } from '@air/api/types';
import { Chip } from '@air/primitive-chip';

import { SectionDisplay } from '~/components/AssetModalV2/InfoPanel/components/SectionDisplay';

export type PublicTagsListProps = {
  tags: Tag[] | undefined;
};

export const PublicTagsList = memo(({ tags }: PublicTagsListProps) => {
  if (!tags?.length) return null;

  return (
    <SectionDisplay title="Tags" data-testid="CUSTOM_METADATA_INFO_PANEL_TAGS">
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <Chip
            appearance="outline"
            shape="rounded"
            size="medium"
            key={tag.id}
            data-testid="CUSTOM_METADATA_INFO_PANEL_TAGS_CHIP"
            data-tag={tag.label}
          >
            <div className="flex items-center">{tag.label}</div>
          </Chip>
        ))}
      </div>
    </SectionDisplay>
  );
});

PublicTagsList.displayName = 'PublicTagsList';
